import { render, staticRenderFns } from "./AddBookingTour.vue?vue&type=template&id=396df2f4"
import script from "./AddBookingTour.vue?vue&type=script&lang=js"
export * from "./AddBookingTour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports